"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectAllVisibility = void 0;
/**
 * {@docCategory DetailsList}
 */
var SelectAllVisibility;
(function (SelectAllVisibility) {
    SelectAllVisibility[SelectAllVisibility["none"] = 0] = "none";
    SelectAllVisibility[SelectAllVisibility["hidden"] = 1] = "hidden";
    SelectAllVisibility[SelectAllVisibility["visible"] = 2] = "visible";
})(SelectAllVisibility || (exports.SelectAllVisibility = SelectAllVisibility = {}));
//# sourceMappingURL=DetailsHeader.types.js.map